<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card elevation="10">
          <v-toolbar color="red accent-2" dark>
            <v-toolbar-title> طلباتي السابقة </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-list>
            <v-list-group
              v-for="item in ListOfOrders"
              :key="item.orderId"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.createDate.replace('T',' ')"
                  ></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-data-table
                hide-default-footer
                :headers="headers"
                :items="item.items"
                items-per-page="1000"
                class="elevation-1"
              ></v-data-table>
            </v-list-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      ListOfOrders: [],
      headers: [
        { text: 'اسم المادة', value: 'itemname' },
        { text: 'العدد', value: 'qty' },
      ],
    };
  },
  created() {
    const baseURI = "https://erp.matein3.com/api/Order/Orders";
    this.$axios.post(baseURI).then((result) => {
      console.log(result.data.data);
      this.ListOfOrders = result.data.data;
    });
  },
};
</script>